<template>
    <div class="modal-card card">
        <div class="card-header border-0 pb-0">
            <h4 class="card-header-title text-danger">Validation failed</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="card-body">
            
            <div v-if="!parsedErrors.length" class="text-muted">
                {{ rawMessage || 'An error occurred during validation.' }}
            </div>

            <div v-else class="validation-error-list">
                <div v-for="(item, idx) in parsedErrors" :key="idx" class="validation-error-item">
                    <div class="validation-error-domain font-monospace fw-semibold">{{ item.domain || 'Domain' }}</div>
                    <ul class="validation-error-messages mb-0">
                        <li v-for="(msg, mi) in item.messages" :key="mi">{{ msg }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ValidationErrorModal",
    props: {
        modalData: {
            type: Object,
            default: null,
        },
    },
    computed: {
        rawMessage() {
            return this.modalData?.rawMessage ?? '';
        },
        parsedErrors() {
            return this.modalData?.parsedErrors ?? [];
        },
    },
};
</script>

<style scoped>
.validation-error-list {
    max-height: 60vh;
    overflow-y: auto;
}

.validation-error-item {
    padding: 0.75rem 1rem;
    margin-bottom: 0.5rem;
    background: #fef2f2;
    border-radius: 6px;
    border-left: 4px solid #dc2626;
}

.validation-error-item:last-child {
    margin-bottom: 0;
}

.validation-error-domain {
    color: #334155;
    margin-bottom: 0.35rem;
    font-size: 0.95rem;
}

.validation-error-messages {
    padding-left: 1.25rem;
    font-size: 0.9rem;
    color: #64748b;
    line-height: 1.5;
}
</style>
